import { useQuery } from '@tanstack/react-query';
import { api } from '../api/client';
import { isPayBasis, type PayBasis } from '../lib/pay-basis';

/**
 * The basis a NEW pay profile on this tenant starts at, from the API
 * (`GET /pay-profiles/defaults`, api#1366): US → Hourly, Canada with
 * earthworks → Hourly, every other tenant → Percentage.
 *
 * The rule is the API's, not this screen's. The two profile screens used to
 * hardcode a default of their own (Hourly in the dialog, Day Rate on
 * /payroll/workers); once the API pays a Canadian Hourly profile from the clock,
 * a default nobody chose would move a percentage hand off ticket pay.
 *
 * `null` while loading or when the read fails — never a guess. A screen that
 * saves with no basis chosen omits `pay_basis`, and the API applies this same
 * rule itself, so an unresolved default cannot store the wrong one.
 */
export function useDefaultPayBasis(enabled = true): PayBasis | null {
  const { data } = useQuery({
    queryKey: ['pay-profiles', 'defaults'],
    queryFn: () => api.payProfiles.defaults(),
    enabled,
    staleTime: 5 * 60 * 1000,
  });
  const value = (data as any)?.data?.data?.defaultPayBasis;
  return isPayBasis(value) ? value : null;
}
